import { render } from "./LearningBaseShowArticle.vue?vue&type=template&id=29248e56&scoped=true"
import script from "./LearningBaseShowArticle.vue?vue&type=script&lang=js"
export * from "./LearningBaseShowArticle.vue?vue&type=script&lang=js"

import "./LearningBaseShowArticle.vue?vue&type=style&index=0&id=29248e56&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29248e56"]])

export default __exports__